/* tslint:disable */
/* eslint-disable */
/**
 * Ion.Reporting.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum UsersNotificationType {
  OngoingLeak = "ongoingLeak",
  OfflineGateway = "offlineGateway",
}

export function UsersNotificationTypeFromJSON(json: any): UsersNotificationType {
  return UsersNotificationTypeFromJSONTyped(json, false);
}

export function UsersNotificationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersNotificationType {
  return json as UsersNotificationType;
}

export function UsersNotificationTypeToJSON(value?: UsersNotificationType | null): any {
  return value as any;
}
